import React, { useEffect, useState } from "react";
import "./Tutorial.scss";
import lvl1Tutorial from "../../../assets/lottie/Instructie_level 1.json"
import lvl2Tutorial from "../../../assets/lottie/Instructie_level 2.json"
import lvl3Tutorial from "../../../assets/lottie/Instructie_level 3.json"
import { useGameState } from "../../../hooks/useGameState";
import { useTranslation } from "react-i18next";
import { Button } from "../../Button/Button";
import { Player } from "@lottiefiles/react-lottie-player";

const gameTutorials = [
    lvl1Tutorial,
    lvl2Tutorial,
    lvl3Tutorial,
]

interface IProps {

}

export function Tutorial(props: IProps) {
    const { t } = useTranslation();
    const { level, gameState, setGameState } = useGameState();
    const [rendered, setRendered] = useState(false);
    const [showButton, setShowButton] = useState(false);

    const activeTutorial = (gameState === 'playing' || gameState === 'level-tutorial' || gameState === 'level-doors') ?
        gameTutorials[level - 1] :
        undefined;

    useEffect(() => {
        setRendered(false);
        requestAnimationFrame(() => {
            setRendered(true);
        });

        const buttonTimer = setTimeout(() => {
            setShowButton(true);
        }, 5000);
        return () => {
            setShowButton(false);
            clearTimeout(buttonTimer);
        }

    }, [activeTutorial]);

    if (!rendered) return <></>
    if (!activeTutorial) return <></>;
    return (
        <div className={`tutorial-wrapper ${gameState === 'level-tutorial' ? 'visible' : ''} ${showButton ? 'with-button' : ''}`} onClick={() => setGameState('level-doors')}>
            <Player
                autoplay
                loop
                // renderer={'canvas'}
                src={activeTutorial}
                style={{ width: '100%', height: '100%'}}
            ></Player>
            {/*<dotlottie-player*/}
            {/*    src={activeTutorial}*/}
            {/*    autoplay*/}
            {/*    transparent*/}
            {/*    loop*/}
            {/*    style={{ height: '100%', width: '100%' }}*/}
            {/*/>*/}
            <div className="tutorial-continue-button-wrapper">
                <Button icon={'arrow-right'} variant={'major-alpha'}>{t('generic.continue')}</Button>
            </div>
        </div>
    )
}
